import React from 'react';

import { css } from '@emotion/css';
function Welcome(props) {

    return (
        <div className={css`
            text-align:center;
        `}>
            <h1>Welcome to the Pokemon World!!</h1>
        </div>
    )
}

Welcome.propTypes = {

}

export default Welcome
